/**
 * A utility to combine the properties of multiple classes
 */
export class MixinUtil {
  /**
   *
   * @param derivedCtor - The object to receive the new properties
   * @param baseCtors - The objects from which to copy properties
   */
  public static ApplyMixins(derivedCtor: any, baseCtors: any[]) {
    baseCtors.forEach(baseCtor => {
      Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
        derivedCtor.prototype[name] = baseCtor.prototype[name];
      });
    });
  }
}
